import Vue from 'vue';
import Vuex from 'vuex';
import {auth} from './auth.module';
import {search} from './search.module';
import {order} from './order.module';
import {bike} from './bike.module';
import {user} from './user.module';
import {selectDates} from './select-dates.module';
import {place} from './place.module';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
      openMenu: false
    },
    actions: {
      openMenuMobile({commit}, payload) {
        commit('menuMobile', payload);
      }
    },
    mutations: {
      menuMobile(state, payload) {
        state.openMenu = payload
      }
    },
    modules: {
        auth,
        search,
        order,
        bike,
        selectDates,
        user,
        place
    }
});
